import { errorPageState } from './error-page.states';
import type { StateService } from '@uirouter/angularjs';
import { ICompileService, IDocumentService, IRootScopeService, IScope, material, element } from 'angular';
import type { I18n } from '../i18n/mx-internationalization';
import type { NotificationService } from '../App/services/mx-notification-service';
import { utils } from '../Utils/mx-utils';

class PopupController {
	static readonly $inject = ['$mdDialog', 'params'];
	constructor(
		private readonly $mdDialog: material.IDialogService,
		private readonly params: { title: string; text: string }
	) {}
	hide() {
		this.$mdDialog.hide();
	}
}

/**
 * @ngdoc service
 * @module mx.sb.ErrorPage
 *
 * @description
 * Provides a functionality for showing Error Posters
 */
export class ErrorPosterService {
	public static readonly $inject = ['$state', '$document', 'mx.shell.NotificationService', 'mx.internationalization', '$mdDialog', '$rootScope', '$compile'];
	public isShown = false;
	private infoPanel?: JQLite;

	constructor(
		private readonly $state: StateService,
		private readonly $document: IDocumentService,
		private readonly notificationService: NotificationService,
		private readonly i18n: I18n,
		private readonly $mdDialog: material.IDialogService,
		private readonly $rootScope: IRootScopeService,
		private readonly $compile: ICompileService
	) {}

	show(title: string, text: string): void {
		if (!this.isShown) {
			this.isShown = true;
			if (this.$state.includes('shell')) {
				this.showInfoPanel(title, text);
				this.showPopup(title, text);
			} else {
				this.showErrorPosterPage(title, text);
			}
		}
	}

	hide(): void {
		this.isShown = false;
		this.hideInfoPanel();
	}

	showErrorPosterPage(title: string, text: string): void {
		this.$state.go(errorPageState.name, {
			errorTitle: title,
			error: text,
		});
	}

	showInfoPanel(title: string, text: string): void {
		const body = this.$document.find('body').eq(0);
		this.infoPanel = element(
			`<div class="error-poster-info-panel" tabindex="-1" ng-click="errorPosterService.showPopup(showInfoPanelTitle, showInfoPanelText)">${utils.htmlEncode(title)}</div>`
		);
		body.prepend(this.infoPanel);
		const localScope: IScope & { errorPosterService?: ErrorPosterService; showInfoPanelTitle?: string; showInfoPanelText?: string } = this.$rootScope.$new();
		localScope.errorPosterService = this;
		localScope.showInfoPanelTitle = title;
		localScope.showInfoPanelText = text;
		this.$compile(this.infoPanel)(localScope);
	}

	hideInfoPanel(): void {
		if (this.infoPanel) {
			this.infoPanel.empty();
			this.infoPanel.detach();
			delete this.infoPanel;
		}
	}

	showPopup(title: string, text: string): void {
		this.notificationService.customDialog({
			openFrom: this.infoPanel && this.infoPanel[0],
			closeTo: this.infoPanel && this.infoPanel[0],
			controllerAs: 'vm',
			controller: PopupController,
			locals: { params: { title, text } },
			template: `
				<div class="mx-dialog-content-message" style="min-width: 50vw;">
				<md-dialog-content class="md-dialog-content">
					<mx-shell-error-message
						error-title="vm.params.title"
						error="vm.params.text">
					</mx-shell-error-message>
				</md-dialog-content>
				<md-dialog-actions>
					<md-button ng-click="vm.hide()" class="md-confirm-button md-primary">${this.i18n.get('shell.common.ok')}</md-button>
				</md-dialog-actions>
				</div>
			`,
		});
	}
}
